import axios from 'axios'
import { ApiConfig } from '../../config/api'
import { AsnReceptionPositionInfoDto } from './types'

const scanParamKey: Record<string, string> = {
  ASN: 'asnNumber',
  LPN: 'lpn',
  TN: 'trackingNumber'
}

//Obtenemos las ASN por filtros
export const getAsnReception = (scanType: string, scanValue: string) => {
  const url = new URL(`${ApiConfig.AsnReceptionApi}`)
  url.searchParams.set(scanParamKey[scanType] ?? 'asnNumber', scanValue)
  url.searchParams.set('pageSize', '50')
  return axios.get(url.toString())
}

//Obtenemos las ASN por Proveedor
export const getAsnReceptionBySupplierId = (supplierId: number, typeAsnId: number) => {
  const url = new URL(`${ApiConfig.AsnReceptionApi}`)
  url.searchParams.set('supplierId', supplierId.toString())
  url.searchParams.set('typeAsnId', typeAsnId.toString())
  url.searchParams.set('pageSize', '50')
  return axios.get(url.toString())
}

//Obtenemos las ASN por Origen de proveedor
export const getAsnReceptionBySupplierOriginId = (supplierOriginId: number, typeAsnId: number) => {
  const url = new URL(`${ApiConfig.AsnReceptionApi}`)
  url.searchParams.set('supplierOriginId', supplierOriginId.toString())
  url.searchParams.set('typeAsnId', typeAsnId.toString())
  url.searchParams.set('pageSize', '50')
  return axios.get(url.toString())
}

//Obtenemos las ASN por Prioridad
export const getAsnReceptionByPriority = (typeAsnId: number) => {
  const url = new URL(`${ApiConfig.AsnReceptionApi}`)
  url.searchParams.set('byPriority', 'true')
  url.searchParams.set('typeAsnId', typeAsnId.toString())
  url.searchParams.set('pageSize', '50')
  return axios.get(url.toString())
}

//Obtenemos las ASN por SKU
export const getAsnReceptionBySkuEan = (skuEan: string, typeAsnId: number) => {
  const url = new URL(`${ApiConfig.AsnReceptionApi}`)
  url.searchParams.set('skuEan', skuEan)
  url.searchParams.set('typeAsnId', typeAsnId.toString())
  url.searchParams.set('pageSize', '50')
  return axios.get(url.toString())
}

//Obtenemos las lpns de una asn
export const getAsnLpns = (asnId: number) =>
  axios.get(`${ApiConfig.AsnReceptionApi}/${asnId}/Lpns`)

//Actualizamos a los usuarios de una lpn
export const registerUserOnLpn = (asnId: number, lpn: string, userId: number) =>
  axios.put(`${ApiConfig.AsnReceptionApi}/${asnId}/UpdateUserByLpn?lpn=${lpn}&userId=${userId}`)

//Obtenemos la work order con SKUs pendientes para ubicación
export const getWorkOrder = (asnId: number, lpn?: string) =>
  axios.get(`${ApiConfig.AsnReceptionApi}/${asnId}/WorkOrder`, {
    params: lpn ? { lpn } : {}
  })

//Valida la posición usando el nuevo endpoint AsnReception (nuevo putaway)
export const checkPosition = (
  positionCode: string,
  typeStorageId: number,
  isReserve: boolean,
  isPreSale: boolean,
  warehouseId: number,
  typeOperationId: number
) =>
  axios.get<AsnReceptionPositionInfoDto>(`${ApiConfig.AsnReceptionApi}/CheckPosition/${positionCode}`, {
    params: { typeStorageId, isReserve, isPreSale, warehouseId, typeOperationId }
  })

//Validamos que el SKU sea compatible con la posición
export const validateSku = (skuId: number, positionId: number) =>
  axios.get(`${ApiConfig.InboundApi}/ValidateSku`, { params: { skuId, positionId } })

//Obtenemos los lotes de un SKU en una ASN
export const getAsnSkuBatches = (
  asnId: number,
  skuId: number,
  lpn?: string,
  batchNumber?: string,
  batchStateIds?: number[],
  pageSize: number = 50
) => {
  const url = new URL(`${ApiConfig.AsnApi}/${asnId}/batches`)
  url.searchParams.set('skuId', skuId.toString())
  url.searchParams.set('pageIndex', '0')
  url.searchParams.set('pageSize', pageSize.toString())
  if (lpn) url.searchParams.set('lpn', lpn)
  if (batchNumber) url.searchParams.set('batchNumber', batchNumber)
  if (batchStateIds?.length) {
    batchStateIds.forEach((id) => url.searchParams.append('batchStateId', id.toString()))
  }
  return axios.get(url.toString())
}

//Obtenemos el historial de ubicaciones por ASN (nuevo endpoint)
export const getAsnHistory = (asnId: number, workOrderId: number, lpn?: string) =>
  axios.get(`${ApiConfig.AsnReceptionApi}/${asnId}/History`, {
    params: { workOrderId, ...(lpn ? { lpn } : {}) }
  })

//Actualiza el estado de la LPN (finalizar sin requerir SKUs)
export const updateLpnState = (asnId: number, lpn: string) =>
  axios.patch(`${ApiConfig.AsnDetailUpdateLpnState}/${asnId}`, { lpn, validateState: true })

//Guardamos la ubicación
export const terminateLocateAsn = (body: {
  workOrderId: number
  asnId: number
  lpn: string
  positionId: number
  userId: number
  asnLocatedSkusDto: {
    skuId: number
    locatedQty: number
    batchId?: number
    dun?: string
  }[]
}) => axios.post(`${ApiConfig.AsnReceptionApi}/TerminateLocateASN`, body)

